// Session Status Component
import React from 'react';

interface SessionStatusProps {
  isActive: boolean;
  isConnected: boolean;
}

export const SessionStatus: React.FC<SessionStatusProps> = ({
  isActive,
  isConnected
}) => {
  return (
    <div className="flex items-center space-x-3">
      {/* Session Status */}
      <div className="flex items-center space-x-2">
        <div className={`w-2 h-2 rounded-full ${
          isActive ? 'bg-green-500 animate-pulse' : 'bg-gray-300'
        }`} />
        <span className={`text-sm font-medium ${
          isActive ? 'text-green-700' : 'text-gray-500'
        }`}>
          {isActive ? 'Active' : 'Inactive'}
        </span>
      </div>

      
    </div>
  );
};
